var map = {
	"./arrow-right.png": 2098,
	"./avatar.png": 8308,
	"./back-btn.png": 2372,
	"./expand.png": 8389,
	"./finance.png": 4308,
	"./knowledge.png": 2842,
	"./law.png": 814,
	"./logistics.png": 6331,
	"./logo.png": 6949,
	"./logo_text.png": 8044,
	"./network.png": 2982,
	"./resource.png": 6165,
	"./tax.png": 3241,
	"./tool.png": 3829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;